import { observable, runInAction } from "mobx";
import GlobalState from "./GlobalState";
import { getTrack } from "../mocks/content/tracking";
import { Cities, Terminals } from "../components/pages/terminals/TerminalsCol";

type ContentStateType = {
  home: {
    seo: any;
    pageTitle: string;
    welcome: any;
    firstscreen: {
      title: string;
      text: string;
    };
    secondscreen: {
      title: string;
      text: string;
    };
    thirdscreen: {
      title: string;
      text: string;
      poster: string;
      watchText: string;
      src: string;
    };
    forthscreen: {
      title: string;
      text: string;
      poster: string;
      watchText: string;
      src: string;
    };
    fifthscreen: {
      title: string;
      text: string;
      postTitle: string;
      postImg: string;
      postLink: string;
    };
    buttonYou: {
      title: string;
      link: string;
    };
    buttonBusiness: {
      title: string;
      link: string;
    };
    buttonFriendly: {
      title: string;
      link: string;
    };
    commerce: any | null;
    marketplace: any | null;
    cookies: any | null;
  } | null;
  menu: {
    account: string;
    track: string;
    list: Array<{ title: string; link: string }>;
  } | null;
  headerLogo: string;
  navigation: Array<{ title: string; link: string }> | null;
  subMenu: {
    list: Array<{ title: string; link: string }>;
    foryou: string;
    forbusiness: string;
    send: {
      title: string;
      link: string;
    };
    foryouLink: "";
    forbusinessLink: "";
    recieve: {
      title: string;
      link: string;
    };
    export: {
      title: string;
      link: string;
    };
    import: {
      title: string;
      link: string;
    };
  } | null;
  footer: {
    companies: string;
    addInfo: string;
    cols: Array<Array<{ title: string; link: string }>>;
    coopButton: string;
    globalIcon: string;
    userIcon: string;
    phone: string;
    phoneDivider: string;
    cabinetTitle: string;
    company: string;
    rules: string;
    socials: {
      fb: {
        src: string;
        link: string;
      };
      insta: {
        src: string;
        link: string;
      };
      linkedin: {
        src: string;
        link: string;
      };
      twitter: {
        src: string;
        link: string;
      };
    } | null;
    apps: {
      google: {
        src: string;
        link: string;
      };
      apple: {
        src: string;
        link: string;
      };
      hua: {
        src: string;
        link: string;
      };
    } | null;
  } | null;
  contact: any;
  news: any;
  newsPost: any;
  login: {
    title: string;
    passwordLabel: string;
    rememberText: string;
    forgotPass: string;
    loginText: string;
    loginBySocial: {
      title: string;
      fbText: string;
      googleText: string;
    };
    noaccount: string;
    registrText: string;
    errorText: string;
  } | null;
  forgot: {
    title: string;
    text: string;
    emptyFillError: string;
    incorrectEmail: string;
    sendBut: string;
    rememberText: string;
    sendEmail: {
      title: string;
      text: string;
      butText: string;
    };
  } | null;
  registr: {
    title: string;
    text: string;
    passwordLabel: string;
    loginText: string;
    registrText: string;
    loginBySocial: {
      title: string;
      fbText: string;
      googleText: string;
    };
    accountText: string;
    errorText: string;
    personal: {
      title: string;
      mainText: string;
      nameText: string;
      lastNameText: string;
      chooseCountry: string;
      phoneText: string;
      emptyError: string;
      incorrectError: string;
      text: string;
      butReg: string;
      exitBut: string;
    };
  } | null;
  tracking: any;
  coop: {
    yourmessage: string;
    title: string;
    text: string;
    fullname: string;
    company: string;
    position: string;
    phone: string;
    website: string;
    topic: string;
    message: string;
    addfile: string;
    send: string;
    tabs: Array<string>;
    privatetopics: Array<string>;
    businessTopic: Array<string>;
    emptyEmail: string;
    incorrectEmail: string;
    emptyTopic: string;
    emptyMsg: string;
    thanks: {
      title: string;
      text: string;
    };
  } | null;
  products: {
    title: string;
    tabs: Array<string>;
    buttonText: string;
    foryou: {
      img: string | null;
      video: null | string;
      poster: null | string;
      products: [
        {
          title: string;
          list: Array<{
            icon: string;
            icons: Array<string>;
            title: string;
            subtitle: string;
            text: string;
            comment: string;
          }>;
        }
      ];
      services: Array<{
        title: string;
        list: Array<{
          title: string;
          icon: string;
          text: string;
        }>;
      }>;
      services2: Array<{
        title: string;
        list: Array<{
          title: string;
          src: string | null;
          poster: string | null;
          video: string | null;
        }>;
      }>;
      digital: Array<{
        title: string;
        list: Array<{
          title: string;
          src: string | null;
          poster: string | null;
          video: string | null;
        }>;
      }>;
    };
    business: {
      img: string | null;
      video: string | null;
      poster: string | null;
      products: Array<{
        title: string;
        list: Array<{
          icon: string | null;
          icons: Array<string | null>;
          title: string;
          subtitle: string;
          text: string;
          comment: string | null;
        }>;
      }>;
      services: Array<{
        title: string;
        list: Array<{
          title: string;
          icon: string | null;
          text: string;
        }>;
      }>;
      services2: Array<{
        title: string;
        list: Array<{
          title: string;
          src: string | null;
          poster: string | null;
          video: string | null;
        }>;
      }>;
      digital: Array<{
        title: string;
        list: Array<{
          title: string;
          src: string | null;
          poster: string | null;
          video: string | null;
        }>;
      }>;
    };
  } | null;

  nofound: {
    subtitle: string;
    title: string;
    text: string;
  } | null;
  documents: Array<{
    title: string;
    link: string;
    subtitle: string;
    blocks: Array<any>;
    butText: string;
    butLink: string;
  }> | null;

  about: {
    conferences: any;
    firstscreen: any;
    keymarkets: any;
    npggroup: any;
    offices: Array<{
      title: string;
      list: Array<{
        text: string;
        icon: string;
      }>;
    }>;
    pageTitle: string;
    intro: {
      title: string;
      showCountries: string;
      menuList: Array<{
        title: string;
        anchor: string;
      }>;
    };
    nolimit: {
      title: string;
      text: string;
      imgDesk: string | null;
      imgMob: string | null;
      video: string | null;
      poster: string | null;
      list: Array<{
        icon: string | null;
        text: string;
      }>;
    };
    whowe: {
      img: string | null;
      video: string | null;
      poster: string | null;
      title: string;
      text: string;
      img2: string | null;
      video2: string | null;
      poster2: string | null;
      text2: string;
    };
    we: {
      main: {
        title: string;
        text: string;
        img: string | null;
        video: string | null;
        poster: string | null;
        list: Array<{
          end: string;
          text: string;
          count: number;
        }>;
      };
      solutions: {
        title: string;
        list: Array<{
          title: string;
          src: string | null;
          poster: string | null;
          video: string | null;
          text: string;
          numbers: Array<{
            num: number;
            text: string;
            end: string;
          }>;
        }>;
      };
      lines: {
        title: string;
        list: Array<string>;
        icons: Array<string>;
      };
      terminals: {
        title: string;
        slides: Array<{
          title: string;
          text: string;
          video: string | null;
          image: string | null;
          poster: string | null;
        }>;
      };
    };
    foryou: {
      title: string;
      text: string;
      imgDesk: string | null;
      imgMob: string | null;
      poster: string | null;
      src: string | null;
      buttonText: string;
      list: Array<{
        title: string;
        src: string | null;
        poster: string | null;
        video: string | null;
        text: string;
        numbers: Array<{
          text: string;
          num: number;
          end: string;
        }>;
      }>;
    };
    shop: Array<string>;
    business: {
      buttonText: string;
      img: string | null;
      title: string;
      text: string;
      blocks: Array<{
        title: string;
        src: string | null;
        poster: string | null;
        video: string | null;
        text: string;

        numbers: Array<{
          end: string;
          num: number;
          text: string;
        }>;
      }>;
      list: Array<{
        count: number;
        text: string;
        end: string;
      }>;
    };
    friendly: {
      title: string;
      text: string;
      imgDesk: string | null;
      imgMob: string | null;
      poster: string | null;
      video: string | null;
      list: Array<{
        text: string;
        count: number;
        end: string;
      }>;
      apps: {
        imgMob: string | null;
        imgDesk: string | null;
        title: string;
        text: string;
        list: Array<{
          rating: number;
          title: string;
          downloads: number;
          link: string;
        }>;
      };
      eco: {
        title: string;
        list: Array<{
          title: string;
          icon: string | null;
          text: string;
        }>;
        tab: {
          src: string | null;
          text: string;
          numbers: Array<{
            text: string;
            end: string;
            num: number;
          }>;
        };
      };
      lead: {
        title: string;
        text: string;
        poster: string | null;
        img: string | null;
        video: string | null;
        list: Array<{
          title: string;
          icon: string | null;
        }>;
      };
      future: {
        title: string;
        slides: Array<{
          title: string;
          text: string;
          src: string | null;
        }>;
      };
    };
    coop: {
      title: string;
      text: string;
      list: Array<string>;
    };
    team: {
      title: string;
      text: string;
      list: Array<{
        title: string;
        link: string | null;
        src: string | null;
        position: string;
        country: string;
      }>;
    };
    watchText: string | null;
    buttonYou: {
      title: string;
      link: string;
    };
    buttonBusiness: {
      title: string;
      link: string;
    };
    buttonCoop: {
      title: string;
      link: string;
    };
  } | null;
  search: any;
  career: any;
  things: any;
  services: any;
  tariffs: any;
  clearance: any;
  acdocs: any;
  faq: any;
  business: any;
  terminals: any;
  localeMenu: any;
  product: any;
  mission: any;
};

const ContentState: ContentStateType = observable({
  home: null,
  about: null,
  headerLogo: "",
  navigation: [],
  menu: null,
  subMenu: null,
  footer: null,
  contact: null,
  news: null,
  newsPost: null,
  login: null,
  forgot: null,
  registr: null,
  tracking: null,
  coop: null,
  products: null,
  search: null,
  nofound: null,
  documents: null,
  career: null,
  things: null,
  services: null,
  tariffs: null,
  clearance: null,
  acdocs: null,
  faq: null,
  business: null,
  terminals: null,
  localeMenu: null,
  product: null,
  mission: null,
});

export default ContentState;

export const getNoFoundContent = async () => {
  try {
    const fd = new FormData();
    fd.append("lang", GlobalState.currentLocale.lang);
    fd.append("status", "error-page");

    const request = await fetch(GlobalState.domain, {
      method: "POST",
      body: fd,
    });

    const response = await request.json();

    runInAction(() => {
      ContentState.nofound = response;
    });
  } catch (e) {
    console.log(e);
  }
};

export const getDocumentsContent = async () => {
  try {
    const fd = new FormData();
    fd.append("lang", GlobalState.currentLocale.lang);
    fd.append("status", "menu-doc");

    const request = await fetch(GlobalState.domain, {
      method: "POST",
      body: fd,
    });

    const response = await request.json();

    runInAction(() => {
      ContentState.documents = response;
    });
  } catch (e) {
    console.log(e);
  }
};

export const getMenu = async () => {
  try {
    const fd = new FormData();
    fd.append("lang", GlobalState.currentLocale.lang);
    fd.append("status", "menu");

    const request = await fetch(GlobalState.domain, {
      method: "POST",
      body: fd,
    });

    const response = await request.json();

    runInAction(() => {
      ContentState.menu = response;
    });
  } catch (e) {
    console.log(e);
  }
};

export const getSubMenu = async () => {
  try {
    const fd = new FormData();
    fd.append("lang", GlobalState.currentLocale.lang);
    fd.append("status", "submenu");

    const request = await fetch(GlobalState.domain, {
      method: "POST",
      body: fd,
    });

    const response = await request.json();

    runInAction(() => {
      ContentState.subMenu = response;
    });
  } catch (e) {
    console.log(e);
  }
};

export const getFooter = async () => {
  try {
    const fd = new FormData();
    fd.append("lang", GlobalState.currentLocale.lang);
    fd.append("status", "footer");

    const request = await fetch(GlobalState.domain, {
      method: "POST",
      body: fd,
    });

    const response = await request.json();

    runInAction(() => {
      ContentState.footer = response;
    });
  } catch (e) {
    console.log(e);
  }
};

export const getHomeContent = async () => {
  try {
    const fd = new FormData();
    fd.append("lang", GlobalState.currentLocale.lang);
    fd.append("status", "home");

    const request = await fetch(GlobalState.domain, {
      method: "POST",
      body: fd,
    });

    const response = await request.json();

    runInAction(() => {
      ContentState.home = response;
    });
  } catch (e) {
    console.log(e);
  }
};

export const getAboutContent = async () => {
  try {
    const fd = new FormData();
    fd.append("lang", GlobalState.currentLocale.lang);
    fd.append("status", "about");

    const request = await fetch(GlobalState.domain, {
      method: "POST",
      body: fd,
    });

    const response = await request.json();

    runInAction(() => {
      ContentState.about = response;
    });
  } catch (e) {
    console.log(e);
  }
};

export const getContantContent = async () => {
  try {
    const fd = new FormData();
    fd.append("lang", GlobalState.currentLocale.lang);
    fd.append("status", "contacts");

    const request = await fetch(GlobalState.domain, {
      method: "POST",
      body: fd,
    });

    const response = await request.json();

    runInAction(() => {
      ContentState.contact = response;
    });
  } catch (e) {
    console.log(e);
  }
};

export const getNewsContent = async () => {
  try {
    const fd = new FormData();
    fd.append("lang", GlobalState.currentLocale.lang);
    fd.append("status", "news-page");

    const request = await fetch(GlobalState.domain, {
      method: "POST",
      body: fd,
    });

    const response = await request.json();

    runInAction(() => {
      ContentState.news = response;
    });
  } catch (e) {
    console.log(e);
  }
};

export const getNewsPostContent = async (id: number) => {
  try {
    const fd = new FormData();
    fd.append("lang", GlobalState.currentLocale.lang);
    fd.append("id", id.toString());
    fd.append("status", "single-news");

    const request = await fetch(GlobalState.domain, {
      method: "POST",
      body: fd,
    });

    const response = await request.json();

    runInAction(() => {
      ContentState.newsPost = response;
    });
  } catch (e) {
    console.log(e);
  }
};

export const getLoginContent = async () => {
  try {
    const fd = new FormData();
    fd.append("lang", GlobalState.currentLocale.lang);
    fd.append("status", "login-page");

    const request = await fetch(GlobalState.domain, {
      method: "POST",
      body: fd,
    });

    const response = await request.json();

    runInAction(() => {
      ContentState.login = response;
    });
  } catch (e) {
    console.log(e);
  }
};

export const getForgotContent = async () => {
  try {
    const fd = new FormData();
    fd.append("lang", GlobalState.currentLocale.lang);
    fd.append("status", "forgot-page");

    const request = await fetch(GlobalState.domain, {
      method: "POST",
      body: fd,
    });

    const response = await request.json();

    runInAction(() => {
      ContentState.forgot = response;
    });
  } catch (e) {
    console.log(e);
  }
};

export const getEmailContent = async () => {
  try {
    const fd = new FormData();
    fd.append("lang", GlobalState.currentLocale.lang);
    fd.append("status", "send-email");

    const request = await fetch(GlobalState.domain, {
      method: "POST",
      body: fd,
    });

    const response = await request.json();

    runInAction(() => {
      ContentState.newsPost = response;
    });
  } catch (e) {
    console.log(e);
  }
};

export const getRegContent = async () => {
  try {
    const fd = new FormData();
    fd.append("lang", GlobalState.currentLocale.lang);
    fd.append("status", "reg-page");

    const request = await fetch(GlobalState.domain, {
      method: "POST",
      body: fd,
    });

    const response = await request.json();

    runInAction(() => {
      ContentState.registr = response;
    });
  } catch (e) {
    console.log(e);
  }
};

export const getTrackingContent = async () => {
  try {
    const lang = GlobalState.currentLocale.lang;

    runInAction(() => {
      ContentState.tracking = getTrack(lang);
    });
  } catch (e) {
    console.log(e);
  }
};

export const getCoopContent = async () => {
  try {
    const fd = new FormData();
    fd.append("lang", GlobalState.currentLocale.lang);
    fd.append("status", "form-page");

    const request = await fetch(GlobalState.domain, {
      method: "POST",
      body: fd,
    });

    const response = await request.json();

    runInAction(() => {
      ContentState.coop = response;
    });
  } catch (e) {
    console.log(e);
  }
};

export const getProductsPage = async () => {
  try {
    const fd = new FormData();
    fd.append("lang", GlobalState.currentLocale.lang);
    fd.append("status", "product-page");

    const request = await fetch(GlobalState.domain, {
      method: "POST",
      body: fd,
    });

    const response = await request.json();

    runInAction(() => {
      ContentState.products = response;
    });
  } catch (e) {
    console.log(e);
  }
};

export const getSearchPage = async () => {
  try {
    const fd = new FormData();
    fd.append("lang", GlobalState.currentLocale.lang);
    fd.append("status", "search-page");

    const request = await fetch(GlobalState.domain, {
      method: "POST",
      body: fd,
    });

    const response = await request.json();

    runInAction(() => {
      ContentState.search = response;
    });
  } catch (e) {
    console.log(e);
  }
};

export const getCareerContent = async () => {
  try {
    const fd = new FormData();
    fd.append("lang", GlobalState.currentLocale.lang);
    fd.append("status", "carrer-page");

    const request = await fetch(GlobalState.domain, {
      method: "POST",
      body: fd,
    });

    const response = await request.json();

    runInAction(() => {
      ContentState.career = response;
    });
  } catch (e) {
    console.log(e);
  }
};

export const getThingsContent = async () => {
  try {
    const fd = new FormData();
    fd.append("lang", GlobalState.currentLocale.lang);
    fd.append("status", "productspage");

    const request = await fetch(GlobalState.domain, {
      method: "POST",
      body: fd,
    });

    const response = await request.json();

    runInAction(() => {
      ContentState.things = response;
    });
  } catch (e) {
    console.log(e);
  }
};

export const getBusinessContent = async () => {
  try {
    const fd = new FormData();
    fd.append("lang", GlobalState.currentLocale.lang);
    fd.append("status", "productspage-b");

    const request = await fetch(GlobalState.domain, {
      method: "POST",
      body: fd,
    });

    const response = await request.json();

    runInAction(() => {
      ContentState.things = response;
    });
  } catch (e) {
    console.log(e);
  }
};

export const getServicesContent = async () => {
  try {
    const fd = new FormData();
    fd.append("lang", GlobalState.currentLocale.lang);
    fd.append("status", "servicespage");
    const request = await fetch(GlobalState.domain, {
      method: "POST",
      body: fd,
    });
    const response = await request.json();

    runInAction(() => {
      ContentState.services = response;
    });
  } catch (e) {
    console.log(e);
  }
};
export const getServicesBusinessContent = async () => {
  try {
    const fd = new FormData();
    fd.append("lang", GlobalState.currentLocale.lang);
    fd.append("status", "servicespage-b");
    const request = await fetch(GlobalState.domain, {
      method: "POST",
      body: fd,
    });
    const response = await request.json();

    runInAction(() => {
      ContentState.services = response;
    });
  } catch (e) {
    console.log(e);
  }
};

export const getTariffsContent = async () => {
  try {
    const fd = new FormData();
    fd.append("lang", GlobalState.currentLocale.lang);
    fd.append("status", "tariffs");
    const request = await fetch(GlobalState.domain, {
      method: "POST",
      body: fd,
    });
    const response = await request.json();

    runInAction(() => {
      ContentState.tariffs = response;
    });
  } catch (e) {
    console.log(e);
  }
};

export const getTariffsBussinessContent = async () => {
  try {
    const fd = new FormData();
    fd.append("lang", GlobalState.currentLocale.lang);
    fd.append("status", "tariffs-b");
    const request = await fetch(GlobalState.domain, {
      method: "POST",
      body: fd,
    });
    const response = await request.json();

    runInAction(() => {
      ContentState.tariffs = response;
    });
  } catch (e) {
    console.log(e);
  }
};

export const getClearanceContent = async () => {
  try {
    const fd = new FormData();
    fd.append("lang", GlobalState.currentLocale.lang);
    fd.append("status", "clearance");
    const request = await fetch(GlobalState.domain, {
      method: "POST",
      body: fd,
    });
    const response = await request.json();

    runInAction(() => {
      ContentState.clearance = response;
    });
  } catch (e) {
    console.log(e);
  }
};

export const getClearanceBusinessContent = async () => {
  try {
    const fd = new FormData();
    fd.append("lang", GlobalState.currentLocale.lang);
    fd.append("status", "clearance-b");
    const request = await fetch(GlobalState.domain, {
      method: "POST",
      body: fd,
    });
    const response = await request.json();

    runInAction(() => {
      ContentState.clearance = response;
    });
  } catch (e) {
    console.log(e);
  }
};
export const getAcDocsContent = async () => {
  try {
    const fd = new FormData();
    fd.append("lang", GlobalState.currentLocale.lang);
    fd.append("status", "acdocs");
    const request = await fetch(GlobalState.domain, {
      method: "POST",
      body: fd,
    });
    const response = await request.json();

    runInAction(() => {
      ContentState.acdocs = response;
    });
  } catch (e) {
    console.log(e);
  }
};

export const getAcDocsBusinessContent = async () => {
  try {
    const fd = new FormData();
    fd.append("lang", GlobalState.currentLocale.lang);
    fd.append("status", "acdocs-b");
    const request = await fetch(GlobalState.domain, {
      method: "POST",
      body: fd,
    });
    const response = await request.json();

    runInAction(() => {
      ContentState.acdocs = response;
    });
  } catch (e) {
    console.log(e);
  }
};

export const getFaqContent = async () => {
  try {
    const fd = new FormData();
    fd.append("lang", GlobalState.currentLocale.lang);
    fd.append("status", "faq");
    const request = await fetch(GlobalState.domain, {
      method: "POST",
      body: fd,
    });
    const response = await request.json();

    runInAction(() => {
      ContentState.faq = response;
    });
  } catch (e) {
    console.log(e);
  }
};

export const getFaqBusinessContent = async () => {
  try {
    const fd = new FormData();
    fd.append("lang", GlobalState.currentLocale.lang);
    fd.append("status", "faq-b");
    const request = await fetch(GlobalState.domain, {
      method: "POST",
      body: fd,
    });
    const response = await request.json();

    runInAction(() => {
      ContentState.faq = response;
    });
  } catch (e) {
    console.log(e);
  }
};

export const getTerminalsContent = async () => {
  try {
    const fd = new FormData();
    fd.append("lang", GlobalState.currentLocale.lang);
    fd.append("status", "terminals-page");
    const request = await fetch(GlobalState.domain, {
      method: "POST",
      body: fd,
    });
    const response = await request.json();

    runInAction(() => {
      ContentState.terminals = response;
    });
  } catch (e) {
    console.log(e);
  }
};

export const getCities = async () => {
  try {
    const fd = new FormData();
    fd.append("lang", GlobalState.currentLocale.lang);
    fd.append("status", "terminals-cities");
    const request = await fetch(GlobalState.domain, {
      method: "POST",
      body: fd,
    });
    const response = await request.json();

    runInAction(() => {
      Cities.cities = response;
    });
  } catch (e) {
    console.log(e);
  }
};

export const getTerminals = async (city: string) => {
  try {
    const fd = new FormData();
    fd.append("lang", GlobalState.currentLocale.lang);
    fd.append("city", city);
    fd.append("status", "terminals");
    const request = await fetch(GlobalState.domain, {
      method: "POST",
      body: fd,
    });
    const response = await request.json();

    runInAction(() => {
      Terminals.list = response;
    });
  } catch (e) {
    console.log(e);
  }
};

export const getLocaleMenu = async () => {
  try {
    const fd = new FormData();
    fd.append("lang", GlobalState.currentLocale.lang);
    fd.append("status", "locale-menu");
    const request = await fetch(GlobalState.domain, {
      method: "POST",
      body: fd,
    });
    const response = await request.json();

    runInAction(() => {
      ContentState.localeMenu = response;
    });
  } catch (e) {
    console.log(e);
  }
};

export const getMissionPage = async () => {
  try {
    const fd = new FormData();
    fd.append("lang", GlobalState.currentLocale.lang);
    fd.append("status", "mission");

    const request = await fetch(GlobalState.domain, {
      method: "POST",
      body: fd,
    });
    const response = await request.json();

    runInAction(() => {
      ContentState.mission = response;
    });
  } catch (e) {
    console.log(e);
  }
};
